module.exports = __webpack_public_path__ + "static/og-229d256dd6e7e92ed4930484899afe8f.png";